import React from 'react';
import ExclamationCircle from 'adp-react-icons/lib/fa/exclamation-circle';
import { SdfAlert, SdfFocusPane, SdfQuickStat, SdfShimmer } from '@synerg/react-components';

export default function SubscriberDetails({ associateDetails, onClose, loading, shouldDisplayAlertError = false, consenterAoid }) {

  return (
    <SdfFocusPane
      paneType="floating"
      visible={true}
      acceptLabel="Close"
      hideDismissButton={true}
      onSdfAccept={() => {
        onClose();
      }}
      onSdfDismiss={() => {
        onClose();
      }}
      closeable={true}
      size="sm"
      backdrop={true}
      keyboard={false}
      animation={true}
    >
      <div slot="title" className="mt-10 ml-5">
        Subscriber Info
      </div>
      <div className="px-10">
        {shouldDisplayAlertError &&
          <SdfAlert
            type="error"
            title="Oops! Something went wrong. Please try again."
            icon={<ExclamationCircle />}
          />}
        <div className="text-body-02 mb-5">
          As the subscriber of this application, this person is authorized to provide data consent for the organization.
        </div>
        <div className="text-heading-05 font-bold">Practitioner contact details</div>
        <div className="my-5">
          <SdfQuickStat className="mb-4" size="sm" label="Name">{loading ? <SdfShimmer /> : associateDetails.name ? associateDetails.name : 'N/A'}</SdfQuickStat>
          <SdfQuickStat className="mb-4" size="sm" label="Email">{loading ? <SdfShimmer /> : associateDetails.email ? associateDetails.email : 'N/A'}</SdfQuickStat>
          <SdfQuickStat className="mb-4" size="sm" label="Subscriber AOID">{loading ? <SdfShimmer /> : consenterAoid ? consenterAoid : 'N/A'}</SdfQuickStat>
        </div>
      </div>
    </SdfFocusPane>
  );
}
